import { useNavigate } from '@tanstack/react-router';
import { Eye } from 'lucide-react';

import { usePreviewStore } from '@/stores/previewStore';

/**
 * Sticky notice shown while a trainer / super admin is browsing the student
 * app in "preview as student" mode. Exit returns them to where they came from.
 */
export function PreviewBanner() {
  const navigate = useNavigate();
  const active = usePreviewStore((s) => s.active);
  const batchName = usePreviewStore((s) => s.batchName);
  const returnTo = usePreviewStore((s) => s.returnTo);
  const exitPreview = usePreviewStore((s) => s.exitPreview);

  if (!active) return null;

  const handleExit = () => {
    exitPreview();
    navigate({ to: returnTo ?? '/trainer' });
  };

  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1 border-b border-amber-300 bg-amber-50 px-4 py-2 text-sm text-amber-900">
      <span className="flex items-center gap-1.5 font-medium">
        <Eye className="h-4 w-4 flex-shrink-0" />
        Previewing as student
      </span>
      {batchName && <span className="truncate text-amber-800">{batchName}</span>}
      <span className="hidden sm:inline text-amber-700">· read-only</span>
      <button
        type="button"
        onClick={handleExit}
        className="ml-auto rounded-md border border-amber-400 bg-white px-2.5 py-1 text-xs font-semibold text-amber-900 hover:bg-amber-100"
      >
        Exit preview
      </button>
    </div>
  );
}
